<template>
    <div class="fillcontain">
      <div class="table_container">
          <el-row>
            <el-button type="primary" @click="handleEdit(0, '','add')">新增餐桌</el-button>
            <el-button type="warning" @click="downloadQrCode(downloadQrUrl)">下载二维码</el-button>
            <el-button type="warning" @click="downloadQrCode(downloadUrl)">下载餐桌地址</el-button>
          </el-row>
          <br/>

          <el-alert v-if="alert_msg != ''" :title="alert_msg" type="warning"></el-alert>
          <br/>
          <el-table
                :data="tableData"
                style="width: 100%"
                v-loading="loading">
              <el-table-column
                label="H5二维码"
              >
                <template slot-scope="scope">
                  <img :src="scope.row.qrPic" width="180" height="180"/>
                </template>
              </el-table-column>
            <el-table-column
              v-if="hasWechatApp"
              label="微信小程序码"
            >
              <template slot-scope="scope">
                <img :src="scope.row.wechatAppQrPic" width="180" height="180"/>
              </template>
            </el-table-column>
              <el-table-column
                label="餐桌名"
                prop="name">
              </el-table-column>

              <el-table-column
                label="餐桌编号"
                prop="number">
              </el-table-column>

              <el-table-column
                label="uuid"
                prop="uuid">
              </el-table-column>
            <el-table-column
              label="模式"
              :formatter="groupCartFormatter">
            </el-table-column>
            <el-table-column
              label="状态"
              prop="statusStr">
            </el-table-column>

              <el-table-column
                label="备注"
                prop="note"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                label="负责人"
                prop="storeUser.name">
              </el-table-column>

                <el-table-column label="操作" width="260">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      v-if="scope.row.status == 2"
                      @click="handleStatus(scope.row,1)">
                      翻台
                    </el-button>
                    <el-button
                      size="mini"
                      v-if="scope.row.status == 1"
                      @click="handleStatus(scope.row,2)">
                      占用
                    </el-button>
                    <el-button
                      size="mini"
                      @click="handleEdit(scope.$index, scope.row,'edit')">
                        编辑
                    </el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="handleDeleteAlert( scope.row)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pages.page"
                  :page-size="pages.pageSize"
                  layout="total, prev, pager, next"
                  :total="pages.total">
                </el-pagination>
            </div>

            <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" :close-on-click-modal="dialog.close">
                <el-form :model="table">
                    <el-form-item label="餐桌名" label-width="120px">
                        <el-input v-model="table.name" auto-complete="off"  maxlength="20" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="餐桌编号" label-width="120px">
                      <el-input v-model="table.number" auto-complete="off"  maxlength="20" show-word-limit></el-input>
                    </el-form-item>
                  <el-form-item label="最少可坐人数" label-width="120px">
                    <el-input-number v-model="table.minPeopleCount" :min="1" :max="10000" @change="handleMinPeopleCountChange"></el-input-number>
                  </el-form-item>
                  <el-form-item label="最多可坐人数" label-width="120px">
                    <el-input-number v-model="table.maxPeopleCount" :min="table.minPeopleCount" :max="10000"></el-input-number>
                  </el-form-item>
                  <el-form-item label="点餐模式" label-width="120px">
                    <el-select v-model="table.is_group_cart" placeholder="请选择">
                      <el-option
                        v-for="item in groupCarts"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="备注" label-width="100px">
                    <el-input v-model="table.note" type="textarea" rows="4"  maxlength="300" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="负责人" label-width="120px">
                    <el-input v-model="table.storeUserNumber" auto-complete="off" placeholder="输入负责该桌的店员编号"  maxlength="20" show-word-limit></el-input>
                  </el-form-item>
                  <el-form-item label="排队分组" label-width="120px" v-loading="queue_groups_loading">
                    <span v-if="queueGroups == null || queueGroups.length == 0" style="color: red">暂无排队分组,您可以到排队分组页面进行创建分组</span>
                    <el-radio-group v-model="table.queue_group_id" size="medium" v-else>
                      <el-radio border :label="item.id" v-for="(item,index) in queueGroups" :key="index">{{item.name}}(人数：{{item.minPeopleCount}}-{{item.maxPeopleCount}})</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleSave">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                loading:false,
                showQr:1,
                downloadQrUrl:"#",
                downloadUrl:"#",
                alert_msg:"",
                table:{
                    id:0,
                    name:"",
                    number:"",
                    minPeopleCount:1,
                    maxPeopleCount:1,
                    note:"",
                    storeUserNumber:"",
                    queue_group_id:"",
                  is_group_cart:false
                },
              groupCarts: [{
                  value: true,
                  label: '团队点餐'
                }, {
                  value: false,
                  label: "单独点餐",
                }],
                dialog:{
                    dialogFormVisible:false,
                    title:"新增餐桌",
                    close:false,
                },
                pages:{
                    offset: 0,
                    pageSize: 10,
                    page: 1,
                    total: 0,
                },
              queue_groups_loading:false,
              tableData: [],
              hasWechatApp:false,
              queueGroups:[]
            }
        },
        created(){
            this.initData();
        },
        methods: {
            initData(){
              this.loading = true;
              var that = this;
              that.$api.get('/store/tables', that.pages, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    that.tableData = res.data.tables.content;
                    that.pages.total = res.data.tables.totalElements;
                    that.hasWechatApp = res.data.hasWechatApp;
                    that.downloadQrUrl = res.data.download;
                    that.downloadUrl = res.data.downloadUrl;
                    that.alert_msg = res.data.alert_msg;
                    if(res.msg != null && res.msg != ""){
                      this.$message({
                        message: res.msg,
                        type: 'warning'
                      });
                    }
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.loading = false;
              });
            },
            handleMinPeopleCountChange(value){
              if(value > this.table.maxPeopleCount){
                this.table.maxPeopleCount = value;
              }
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.pages.page = val;
                this.pages.offset = (val - 1)*this.pages.pageSize;
                this.initData()
            },
            groupCartFormatter(row){
                if(row.groupCart){
                  return "团队点餐";
                }else{
                  return "单人点餐";
                }
            },
            handleEdit(index, row,action) {

                this.getGoodGroups();

                if(action == "edit"){
                    this.dialog.title = "修改餐桌";
                    this.table.id = row.id;
                    this.table.name = row.name;
                    this.table.number = row.number;
                    this.table.note = row.note;
                    this.table.minPeopleCount=row.minPeopleCount;
                    this.table.maxPeopleCount=row.maxPeopleCount;
                    this.table.storeUserNumber = row.storeUser == null ? "":row.storeUser.number;
                    if(row.tableQueueUpGroup != null) {
                      this.table.queue_group_id = row.tableQueueUpGroup.id;
                    }else{
                      this.table.queue_group_id=0;
                    }
                    this.table.is_group_cart = row.groupCart;

                    this.dialog.dialogFormVisible = true;
                }else if(action == "add"){
                    this.dialog.title = "新增餐桌";
                    this.table.id = 0;
                    this.table.name = "";
                    this.table.number = "";
                    this.table.note = "";
                    this.table.storeUserNumber = "";
                    this.dialog.dialogFormVisible = true;
                    this.table.minPeopleCount=1;
                    this.table.maxPeopleCount=1;
                    this.table.queue_group_id=0;
                    this.table.is_group_cart = false;
                }
            },

            getGoodGroups(){
              this.queue_groups_loading = true;
              //获取标签
              this.groupsChecks = [];
              this.$api.get('/store/queue_up/group', {page:1,pageSize: 10000}, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    this.queueGroups = res.data.queueUpGroups;
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.queue_groups_loading = false;
              });
            },
            handleStatus(row,status){
              this.$api.put('/store/tables/usedStatus/'+row.id, {status:status}, response => {
                if (response.status >= 200 && response.status < 300) {
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: "修改成功",
                      type: 'success'
                    });
                    this.initData();
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }
                this.queue_groups_loading = false;
              });
            },


            downloadQrCode(url){
                location.href=url;
            },

            handleSave() {
              if(this.table.name == ''){
                this.$message({
                  message: "名称不能为空",
                  type: 'warning'
                });
                return;
              }
                this.loading = true;
                var that = this;
                that.$api.post('/store/tables', that.table, response => {
                  if (response.status >= 200 && response.status < 300) {
                    console.log(response.data);
                    var res = response.data;
                    if (res.code == 0) {
                      this.$message({
                        message: that.dialog.title+'成功',
                        type: 'success'
                      });
                      this.dialog.dialogFormVisible = false;
                      this.initData();
                    }else{
                      this.$message({
                        message: res.msg,
                        type: 'warning'
                      });
                    }
                  } else {
                    this.$message({
                      message: "服务器维护中",
                      type: 'error'
                    });
                  }

                });

                this.loading = false;
            },
            handleDeleteAlert(row) {
                this.$confirm('此操作将删除该餐桌, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.handleDelete(row);
                }).catch(() => {

                });
            },
          handleDelete(row) {
            this.loading = true;
            var that = this;
            that.$api.delete('/store/tables/'+row.id, null, response => {
              if (response.status >= 200 && response.status < 300) {
                  console.log(response.data);
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: '删除成功',
                      type: 'success'
                    });
                    this.loading = false;
                    this.initData();
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
              } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
              }

            });
            },
        },
    }
</script>
<style lang="less">
  @import '../../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .table_container{
    padding: 20px;
    text-align: left;
  }
  .Pagination{
    display: flex;
    justify-content: flex-start;
    margin-top: 8px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
  }
</style>

<style>
  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 10px;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }
</style>



// WEBPACK FOOTER //
// src/pages/store/Tables.vue